import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Input, Table, Select } from "antd";

import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import { req_page_ssp_dean_target, req_edit_ssp_dean_target } from "../../api";

class DeanTargetPages extends Component {
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
    options: [
      { label: "待定", value: "0" },
      // { label: "管理學院院長", value: "110" },
      { label: "民生暨管理學院院長", value: "109" },
      { label: "設計學院院長", value: "111" },
      { label: "藝術學院院長", value: "99" },
      // { label: "教務長", value: "16" },
      { label: "招策中心主任", value: "203" },
      { label: "招策中心宣傳組組長", value: "204" },
      { label: "招策中心試務組組長", value: "205" },  
    ],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      planAcademicYear,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_ssp_dean_target(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      planAcademicYear,
      token
    );
    this.setState({ loading: false });
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_edit_item = async (row) => {
    const { token } = this.props.user;
    await req_edit_ssp_dean_target(row, token);
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const { options } = this.state;
    this.columns = [
      {
        title: "學校代號",
        dataIndex: "HighSchoolCode",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源學校",
        dataIndex: "HighSchoolTwName",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "總召",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { DeanPositioinCode } = item;
          return (
            <>
              <Select
                className="form-control"
                style={{
                  display: "inline-block",
                }}
                onChange={(val) => this.handleChange(val, item)}
                defaultValue={DeanPositioinCode}
                options={options}
              ></Select>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handleChange = (value, data) => {
    const { Uid } = data;
    //console.log(value);
    //console.log(Uid);
    const item = {
      condition: "DEAN",
      DeanPositioinCode: value,
      Uid: Uid,
    };
    this.api_edit_item(item);
  };

  handleSelectChange = (event) => {
    const value = event.target.value;
    this.setState({
      searchField: value,
    });
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "download":
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchField, searchValue } = this.state;
    const title = (
      <>
        <select
          className="form-control"
          style={{ width: "120px", display: "inline-block" }}
          onChange={this.handleSelectChange}
          value={searchField}
        >
          <option value="NONE">其他條件</option>
          <option value="HighSchoolTwName">生源學校校名</option>
          <option value="TwName">總召姓名</option>
        </select>
        <Input
          placeholder="關鍵字"
          style={{
            width: 80,
            height: 39,
            margin: "0 5px",
            backgroundColor: "LightYellow",
          }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            margin: "0 5px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </button>
        <button className="btn btn-info" onClick={this.handle_data_refresh}>
          <i className="fas fa-sync-alt"></i>
        </button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(DeanTargetPages);
